import {PropsWithTheme, FocusSchema} from '../types';
import theme from './theme';

const focus = (props: PropsWithTheme): FocusSchema => theme(props).focus;

export const focusOutlineColor = (props: PropsWithTheme): string => focus(props).outlineColor;
export const focusOutlineStyle = (props: PropsWithTheme): string => focus(props).outlineStyle;
export const focusOutlineWidth = (props: PropsWithTheme): string => focus(props).outlineWidth;
export const focusOutlineOffset = (props: PropsWithTheme): string => focus(props).outlineOffset;
